/* eslint-disable import/first */
import { Plugin } from 'vue';
import VueBemCn from '@/plugins/vue-bem-cn';
import resizeEnd from '@/plugins/resize-end';
import viewport from '@/plugins/viewport';
import i18n from '@/setup/i18n'; // MUST come after i18n because of build order.
import directives from '@/setup/directives';
import components from '@/setup/ssr-components';
import dayjs from '@/plugins/dayjs';
import confirmation from '@/plugins/confirmation';
import oxomi from '@/plugins/oxomi';
import userlike from '@/plugins/userlike';
import googleTagManager from '@/plugins/google-tag-manager';

// import VueFocus from '@/plugins/v-focus';
// import tooltip from '@/plugins/tooltip';

export interface CustomPlugin {
  plugin: Plugin;
  options?: Record<string, unknown>;
}

export default [
  { plugin: i18n },
  { plugin: resizeEnd },
  { plugin: viewport },
  {
    plugin: VueBemCn,
    options: { // please note: if you change the VueBemCn methodName, adjust the global definition in shims-plugins.d.ts
      hyphenate: true,
    },
  },
  { plugin: directives },
  { plugin: components },
  // { plugin: tooltip},
  // { plugin: VueFocus},
  { plugin: dayjs },
  { plugin: confirmation },
  { plugin: oxomi },
  { plugin: userlike },
  { plugin: googleTagManager },
] satisfies CustomPlugin[];
